import React from 'react'
import { WithPageTitle, WithTemplate } from '@morningtrain/react-app'
import { Form } from '@morningtrain/react-resources'
import Pin from 'widgets/Pin'
import { Env } from '@morningtrain/helpers'
import LoginPipeline from 'support/pipelines/LoginPipeline'

export default function Login (props) {
  return (
    <WithTemplate template='Auth'>
      <WithPageTitle title={Env.get('globals.department.name')} />
      <Form route='app.auth.login_tablet'>
        <LoginPipeline />
        <Pin />
      </Form>
    </WithTemplate>
  )
}
